import {
    VenueAnalysisAggregatedData,
    VenueAnalysisData,
    VenueAnalysisVenueData,
} from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import {
    computeBarWidths,
    VenueAnalysisVenueDisplayData,
} from 'widgets/venueAnalysis/grid/gridData';
import orderBy from 'lodash/orderBy';

const toDisplayData: (
    vtd?: VenueAnalysisVenueData[]
) => VenueAnalysisVenueDisplayData[] = (vtd) =>
    vtd ? computeBarWidths(vtd) : [];

export function toVenueExecCapsuleData(
    data: VenueAnalysisData,
    combineAfterIndex = -1
) {
    const histVenueData = toVenueData(data?.mktVolHist, combineAfterIndex);
    const todayVenueData = toVenueData(data?.mktVolRealTime, combineAfterIndex);
    const orderVenueData = toVenueData(data?.orderVenue, combineAfterIndex);

    const histDisplayData = toDisplayData(histVenueData);
    const todayDisplayData = toDisplayData(todayVenueData);
    const orderDisplayData = toDisplayData(orderVenueData);

    return { histDisplayData, todayDisplayData, orderDisplayData };
}

function toVenueData(
    aggregatedData?: VenueAnalysisAggregatedData,
    combineAfterIndex = -1
): VenueAnalysisVenueData[] {
    const venues: VenueAnalysisVenueData[] = [];

    for (const vt of aggregatedData?.venueTypes || []) {
        for (const v of vt.venues) {
            venues.push({
                name: v.name,
                micCode: v.micCode,
                percent: (vt.percent * v.percent) / 100,
                qty: v.qty,
                venueTypeName: vt.name,
            });
        }
    }

    const sortedData = orderBy(venues, ['percent'], ['desc']);
    const ret =
        combineAfterIndex > -1
            ? sortedData.slice(0, combineAfterIndex)
            : sortedData;

    if (combineAfterIndex > 1 && sortedData.length > combineAfterIndex) {
        const other: VenueAnalysisVenueData = {
            name: 'Other',
            venueTypeName: 'Other',
            micCode: 'Other',
            percent: 0,
            qty: 0,
        };
        sortedData.slice(combineAfterIndex).forEach((i) => {
            other.qty = other.qty + i.qty;
            other.percent = other.percent + i.percent;
        });
        ret.push(other);
    }

    return ret;
}
